import React, { FC, ReactElement } from 'react';
import { withRouter } from 'react-router-dom';
import { localizeType } from '../../commonType';
import withLocalization from '../hoc/withLocalization';
import './CheckEligibilitySelector.scss';

interface CheckEligibilitySelectorType {
  enabled: boolean;
  localize: localizeType;
  onClick: () => void;
}

const CheckEligibilitySelector: FC<CheckEligibilitySelectorType> = (
  props: CheckEligibilitySelectorType,
): ReactElement => {
  const { localize, enabled, onClick } = props;

  const onCheckInClick = (evt) => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <div className="eligibilityButton">
        <button className="checkInButton palmBg upperCase" onClick={onCheckInClick} disabled={!enabled}>
          {localize('preview-sales-engine.static-content.copy.eligibility-page.check-button')}
        </button>
      </div>
    </>
  );
};

export default withRouter(withLocalization(CheckEligibilitySelector));
